import {
  CountryCode,
  EnvironmentType,
  createCountryFromCountryCode,
  createLocaleFromCountryCode,
  stringToCountryCode,
  stringToEnvironmentType,
  type Build,
} from "@vana/core";

const ENVIRONMENT_TYPE = process.env.ENVIRONMENT_TYPE ?? EnvironmentType.DEV;
const COUNTRY_CODE = process.env.COUNTRY ?? CountryCode.GT;

export const build: Build = {
  // Same-origin BFF proxy path (decision D-3): the browser talks only to the
  // BFF at `/api`. An empty base makes the HTTP client resolve requests
  // relative to the current route (e.g. `/backoffice/v1/...`), which the BFF
  // doesn't proxy → the SPA fallback returns index.html → "200 but no data".
  // Default to `/api` so any build is correct; prod/e2e still override it.
  apiHost: process.env.API_HOST ?? "/api",
  countryCode: stringToCountryCode(COUNTRY_CODE),
  deepLinkHost: process.env.DEEP_LINK_HOST ?? "",
  environmentType: stringToEnvironmentType(ENVIRONMENT_TYPE),
  packageName: process.env.PACKAGE_NAME ?? "",
  packageVersion: process.env.PACKAGE_VERSION ?? "",
  webAppHost: process.env.WEB_APP_HOST ?? "",
};

export const country = createCountryFromCountryCode(build.countryCode);
export const locale = createLocaleFromCountryCode(build.countryCode);
